export default {"src":"/_next/static/media/relapse.colour.5b0a2a17.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};